import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Routes } from "src/app/infrastructure/routes";
import { DeliveryCostGateway } from "../gateway/DeliveryCostGateway";
import { DeliveryCost, NewDeliveryCost } from "src/app/domain/models/DeliveryCost";

@Injectable({providedIn: 'root'})
export class DeliveryCostService extends DeliveryCostGateway {

  constructor(private _http: HttpClient) {
    super()
  }

  create(deliveryCost: NewDeliveryCost): Observable<DeliveryCost> {
    return this._http.post<DeliveryCost>(Routes.deliveryCostApi + '/Create', deliveryCost)
  }

  update(deliveryCost: DeliveryCost): Observable<DeliveryCost> {
    return this._http.put<DeliveryCost>(Routes.deliveryCostApi + '/Update', deliveryCost)
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(Routes.deliveryCostApi + '/Delete', {params: {id}})
  }

  getAllByImportOrderId(importOrderId: any): Observable<DeliveryCost[]> {
    return this._http.get<DeliveryCost[]>(Routes.deliveryCostApi + '/GetAllByImportOrderId', {params: {importOrderId}})
  }
}